module.exports = __webpack_public_path__ + "static/media/train-alt.ca3a690a.svg";